export const GET_NATIONAL_EXAM_LEVELS = 'GET_NATIONAL_EXAM_LEVELS';
export const GET_CANDIDATE_TYPES = 'GET_CANDIDATE_TYPES';
export const POST_RAW_RESULTS_APPEAL_SEARCH = 'POST_RAW_RESULTS_APPEAL_SEARCH';
export const POST_RESULTS_APPEAL_EXPORT_EXCEL = 'POST_RESULTS_APPEAL_EXPORT_EXCEL';
export const GET_RESULTS_APPEAL_DETAIL = 'GET_RESULTS_APPEAL_DETAIL';
